import {
  SET_USER,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_ERRORS,
  SET_UNAUTHENTICATED,
  LOADING_USER,
  SET_CHARGING_STATIONS,
  SET_USER_LOCATION,
} from '../types';
import axios from 'axios';

export const loginUser = (userData, history) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  axios
    .post('/login', userData)
    .then((res) => {
      setAuthorizationHeader(res.data.token);
      dispatch(getUserData());
      dispatch({ type: CLEAR_ERRORS });
      history.push('/Profile');
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};
export const postSideItem = (sideItem, history) => (dispatch) => {
  dispatch({ type: LOADING_USER });
  axios
    .post('/menu/Luis/sides', sideItem)
    .then(() => {
      dispatch(getUserData());
    })
    .catch((err) => console.log(err));
};

export const setUserLocation = (location) => {
  return { type: SET_USER_LOCATION, payload: location };
};

// export const setUserLocation = (event) => (dispatch) => {

// };

export const setChargingStations = (chargingStations) => ({
  type: SET_CHARGING_STATIONS,
  chargingStations,
});

export const signupUser = (newUserData, history) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  axios
    .post('/signup', newUserData)
    .then((res) => {
      setAuthorizationHeader(res.data.token);
      dispatch(getUserData());
      dispatch({ type: CLEAR_ERRORS });
      history.push('/Profile');
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const logoutUser = () => (dispatch) => {
  localStorage.removeItem('FBIdToken');
  delete axios.defaults.headers.common['Authorization'];
  dispatch({ type: SET_UNAUTHENTICATED });
};

export const getUserData = () => (dispatch) => {
  dispatch({ type: LOADING_USER });

  axios
    .get('/user')
    .then((res) => {
      dispatch({
        type: SET_USER,
        payload: res.data,
      });
    })
    .catch((err) => console.log(err));
};
const setAuthorizationHeader = (token) => {
  const FBIdToken = `Bearer ${token}`;
  localStorage.setItem('FBIdToken', FBIdToken);
  axios.defaults.headers.common['Authorization'] = FBIdToken;
};

export const doLocation = (userDetails) => (dispatch) => {
  dispatch(setUserLocation('33333'));
};

export const fetchAllStations = () => async (dispatch) => {
  const { data: chargingStations } = await axios.get(
    'https://us-central1-foodapp-f2809.cloudfunctions.net/api/locations'
  );

  dispatch(setChargingStations(chargingStations));
  //dispatch(setUserLocation("1111"))
};

export const editUserDetails = (userDetails) => (dispatch) => {
  dispatch({ type: LOADING_USER });

  axios
    .post('/user', userDetails)
    .then(() => {
      dispatch(getUserData());
    })
    .catch((err) => console.log(err));
};

export const uploadImage = (formData) => (dispatch) => {
  dispatch({ type: LOADING_USER });
  axios
    .post('/user/image', formData)
    .then(() => {
      dispatch(getUserData());
    })
    .catch((err) => console.log(err));
};
